export enum HeaderComponentMode {
  DEFAULT = 0,
  EXTERNAL_USER = 1,
  TRAINING,
  ANONYMOUS_USER = 4
}